/***
 * 创建人：李珊
 * 时间：2020-12-01
 * 描述: 素材检索
 * 使用说明:
 * 更新说明:
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {SwMassageBoxService} from '../../../../librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from '../../../../librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { KmsService } from '../../kms.service';
import { Router } from '@angular/router';
import { KmsEnum } from '../../serves/kms-enum';
import { environment } from 'src/environments/environment';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { MaterialViewComponent } from '../material-manage/material-view/material-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';

declare var $;
@Component({
  selector: 'app-material-search',
  templateUrl: './material-search.component.html',
  styleUrls: ['./material-search.component.css']
})
export class MaterialSearchComponent implements OnInit {
    // 表格组件
    @ViewChild("swtable") swtable: SwGridTableComponent;  
    // 当前登录用户id
    userId: string;
    // 搜索属性下拉选项
    attrTypeOptions:any = [];
    // 关键字
    keyword: any = '';
    // 查询属性
    searchAttr:any = '';
    // 选中资源类型
    materialCategory:any = '';
    // 选中文本类型
    textType:any = ''; 
    // 上一次查询条件
    lastQueryParams:any = {}; 
    // 是否显示正在加载
    isLoading = false;
    checkedData = []; //选中的内容
    datas: any[] = []; 
    // 分页参数
    pageBase: any = {
      current: 1,
      size: 10
    } 
    fileCategoryOptions = [];
    textTypeOptions = [];
    isInit = true;
    isCompatibleMode = 1;
    constructor(
        private kmsService: KmsService,
        private box:SwMassageBoxService,
        private swMaskService: SwMaskService,
        private jwt: SwJwtService,
        private router: Router,
        private User: GetUserModelService,
        private create: SwCreateModalComponentService,
        private instanceModuleService: InstanceModuleService) {
    }

    ngOnInit() {
      // 获取用户id
      let user = this.User.getUser();
      this.userId = user['userId'];
      // 获取分类数据
      this.fileCategoryOptions = this.instanceModuleService.getResourceTypeOptions();
      this.fileCategoryOptions.forEach(e => {
        if(e['childs'] && e['childs'].length > 0){
          e.childs.forEach(item => {
            if(item.recordFileds.length == 0){
              item.recordFileds = e.recordFileds;
            }
          })
          e.childs.unshift({'id':'all','text':'全部','recordFileds':e.recordFileds});
        }
      });
      const firstItem = this.fileCategoryOptions[0];
      this.materialCategory = firstItem.id;
      this.textTypeOptions = firstItem.childs;
      // 获取属性数据
      this.attrTypeOptions = [
        {id:'resourceName',text:'素材名称'},
        {id:'tagName',text:'研究主题'},
        {id:'allText',text:'全文'}
      ];
      let newAttrs = firstItem['recordFileds'];
      this.attrTypeOptions.splice(2,0,...newAttrs);
      this.searchAttr = this.attrTypeOptions[0].id;
      // 判断当前知识库兼容状态
      let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
      this.isCompatibleMode = kgDbInfo ? kgDbInfo.isCompatibleMode : null;
    }

    //enter键触发搜索
    enterSearch(event){
      if(event.keyCode == '13'){
        this.clickSelect();
      }
    }

    // 查询方法
    clickSelect() {
      let keyword = $.trim(this.keyword);
      if(!keyword){
        this.box.danger('请输入关键字！');
        return;
      }else{
        this.isInit = false;
        const name = this.attrTypeOptions.find(e => e.id == this.searchAttr).text;
        this.lastQueryParams = {
          keyword: keyword,
          searchAttr: this.searchAttr,
          attributeName: name
        }
        this.pageBase = {
          current: 1, 
          size: 10
        };
        this.getData();
      }
    }

    // 选择素材类型
    clickRadio1(item) {
      this.textTypeOptions = item.childs;
      this.attrTypeOptions = [
        {id:'resourceName',text:'素材名称'},
        {id:'tagName',text:'研究主题'},
        {id:'allText',text:'全文'}
      ];
      let newAttrs = item.recordFileds;
      this.attrTypeOptions.splice(2,0,...newAttrs);
      if(!this.attrTypeOptions.find(e => e.id == this.searchAttr)){
        this.searchAttr = this.attrTypeOptions[0].id;
      }

      this.materialCategory = item.id;
      this.textType = item.childs.length > 0 ? item.childs[0].id : '';
      this.clickSelect();
    }

    // 选择文本类型
    clickRadio2(item) {
      this.attrTypeOptions = [
        {id:'resourceName',text:'素材名称'},
        {id:'tagName',text:'研究主题'},
        {id:'allText',text:'全文'}
      ];
      let newAttrs = item.recordFileds;
      if(newAttrs.length > 0){
         this.attrTypeOptions.splice(2,0,...newAttrs);
      }
      if(!this.attrTypeOptions.find(e => e.id == this.searchAttr)){
        this.searchAttr = this.attrTypeOptions[0].id;
      }
      this.textType = item.id;
      this.clickSelect();
    }

    // 点击添加到提取任务
    handleAddClick() {
      if (this.checkedData.length <= 0) {
        this.box.danger('请至少选择一条数据！');
        return;
      } else {
        this.swMaskService.openMask('正在保存数据，请稍候...');
        // 查询当前用户已添加到历史记录中的资源
        const params = {
          current: 1,
          size: 1000,
          userId: this.userId
        }
        this.kmsService.queryExtractResourceList(params).subscribe((res) => {
          if(res["code"] == "200"){
            // 获取当前用户已添加到历史记录中的资源 与 当前选中的资源进行合并
            // 判断是否为全文检索，全文检索需按页码合并；非全文检索，按materialId进行合并
            if(this.lastQueryParams.searchAttr == 'allText'){
              this.mergeData(res.data.records);
            }else{
              this.mergeData2(res.data.records);
            }
          }else{
            this.swMaskService.closeMask();
            this.box.waring(res.msg);
          }
        });
      }
    }

    // 全文检索时：合并数据
    mergeData(oldDatas) {
      // 新选择的数据
      let newData = [];
      this.checkedData.forEach(e => {
        const i = parseInt(e);
        newData.push({
          materialId: this.datas[i].materialId,
          pagesNum: this.datas[i].pagesNum+''
        })
      })
      let res = oldDatas;
      for (let i = 0; i < newData.length; i++) {
        let on = false;
        if(res.length > 0){
          res.forEach(e => {
            // 判断是否选择该资源
            if(e.materialId == newData[i].materialId){
              on = true;
              if(e.pagesNum){
                // 判断是否选择该资源的该页
                const arr = e.pagesNum.split(',');
                if(arr.indexOf(newData[i].pagesNum) == -1){
                  e.pagesNum += (',' + newData[i].pagesNum);
                }
              }
            }
          });
        }
        if(!on){
          res = [...res,newData[i]];
        }
      }
      // 保存所有数据
      this.saveSelections(res);
    }

    // 非全文检索时：合并数据
    mergeData2(oldDatas) {
      // 新选择的数据
      let newData = [];
      this.checkedData.forEach(e => {
        const i = parseInt(e);
        newData.push({
          materialId: this.datas[i].materialId,
          pagesNum: ''
        })
      })
      let res = oldDatas;
      for (let i = 0; i < newData.length; i++) {
        let on = false;
        if(res.length > 0){
          res.forEach(e => {
            // 判断是否选择该资源
            if(e.materialId == newData[i].materialId){
              on = true;
              e.pagesNum = '';
            }
          });
        }
        if(!on){
          res = [...res,newData[i]];
        }
      }
      // 保存所有数据
      this.saveSelections(res);
    }

    // 保存所有数据
    saveSelections(res) {
      let arr = [];
      res.forEach(e => {
        let item = {
          materialId: e.materialId,
          pagesNum: e.pagesNum,
          userId: this.userId
        }
        if(e.pagesNum){
          let arr1 = e.pagesNum.split(',').map(e1 => parseInt(e1));
          arr1 = arr1.sort((a, b) => a - b);
          item.pagesNum = arr1.join(',');
        }
        arr.push(item);
      });
      this.kmsService.saveExtractResources(arr).subscribe((res) => {
        this.swMaskService.closeMask();
        if(res["code"] == "200"){
          this.box.success("已添加到提取任务!");
          $('#selectedResourceNum').text(arr.length);
          this.jwt.setToKen("selectedResourceNum",arr.length);
        } else {
          this.box.waring(res.msg);
        }
      });
    }

    // 全选
    clickChecedAll() {
      let br = $("#CheAll")[0].checked;
      $("#UserMaintion input[type='checkbox']").prop("checked", br);
      //将选中的数据保存起来
      if (br) {
        var checkedAll = $("#UserMaintion input[type='checkbox']:Checked");
        for (let i = 0; checkedAll.length > i; i++) {
          if (this.checkedData.indexOf(checkedAll[i].id) === -1) {
            this.checkedData.push(checkedAll[i].id)
          }
        }
      } else {
        this.checkedData = [];
      }
    }

    // 点击div触发checkbox点击事件
    clickDescBox(i,isDisabled) {
      if(isDisabled){
        return;
      }
      $('#UserMaintion .full-item').eq(i).find('input:checkbox').trigger('click');
    }

    // 单选
    clickCheced(index) {
      //禁止冒泡
      event.stopPropagation();
      // 获取当前单选框的状态
      const checkbox = $("#UserMaintion input[type='checkbox']").eq(index)[0];
      const isChecked = checkbox.checked; // 当前复选框的选中状态
      if (isChecked) {
        if (this.checkedData.indexOf(checkbox.id) === -1) {
          this.checkedData.push(checkbox.id);
        }
      } else {
        const idx = this.checkedData.indexOf(checkbox.id);
        if (idx !== -1) {
          this.checkedData.splice(idx, 1);
        }
      }
      this.updateSelectAll();
    }

    // 设置全选按钮的选中状态
    updateSelectAll() {
      // 检查是否所有复选框都被选中
      const allChecked = $("#UserMaintion input[type='checkbox']").length ==  $("#UserMaintion input[type='checkbox']:checked").length;
      $("#CheAll")[0].checked = allChecked;
    }

    // 高级检索
    advancedSearch() {
      this.router.navigate(['/kms/advancedSearch'], {
        queryParams: { Title: '高级检索' }
      });
    }

    //获取表格数据
    getData(){
      this.isLoading = true;
      // 全文检索
      if(this.lastQueryParams.searchAttr === 'allText'){
        let params = {
          'current': this.pageBase.current,
          'size': this.pageBase.size,
          'keyword': this.lastQueryParams.keyword,
          'materialCategory': this.materialCategory,
          'textType': this.textType == 'all' ? '' : this.textType
        }
        this.kmsService.fullTextQuery(params).subscribe(
          res => {
            this.isLoading = false;
            this.checkedData = [];
            if(res.code == 200){
              this.pageBase = res.data;
              this.datas = res.data.records? res.data.records : [];
              if(this.datas.length>0){
                this.datas.forEach(e => {
                  e.materialTitle = this.replaceKeyword(e.materialTitle, this.lastQueryParams.keyword);
                  e.src = '';
                  if(e.filePath){
                    const url = e.filePath;
                    const pathArr = url.split('/');
                    let str = '';
                    for(let i=0;i<pathArr.length;i++){
                      if(i == pathArr.length - 1){
                        const arr = pathArr[i].split('.');
                        str += 'THUMB/'+(arr[0]+"_300@x." +arr[1]);
                      }else{
                        str += pathArr[i]+'/';
                      }
                    }
                    e.src = environment.staticFileUrl + str;
                  }
                  e['searchCon'] = this.extractContext(e.materialText, this.lastQueryParams.keyword);
                })
              }
            }else{
              this.box.waring(res.msg);
            }
          }
        )
      }
      // 其他属性检索
      else{
        let params = {
          'current': this.pageBase.current,
          'size': this.pageBase.size,
          'resourceType': this.materialCategory,
          'textType': this.textType == 'all' ? '' : this.textType,
          "resourceName": "",
          "tagName": "",
          "resourceAttrParams": []
        }
        if(this.lastQueryParams.searchAttr == 'resourceName'){
          params.resourceName = this.lastQueryParams.keyword;
        }
        else if(this.lastQueryParams.searchAttr =='tagName'){
          params.tagName = this.lastQueryParams.keyword;
        }
        else{
          params.resourceAttrParams.push({
            "attributeCode": this.lastQueryParams.searchAttr,
            "attributeValue": this.lastQueryParams.keyword
          });
        }
        this.kmsService.esResourceSearch(params).subscribe(
          res => {
            this.isLoading = false;
            this.checkedData = [];
            if(res.code == 200){
              this.pageBase = res.data;
              this.datas = res.data.records? res.data.records : [];
              if(this.datas.length>0){
                this.datas.forEach(item => {
                  item.materialTitle = this.replaceKeyword(item.materialTitle, this.lastQueryParams.keyword);
                  item.description = item.description ? item.description : '';
                  item.description = this.replaceKeyword(item.description, this.lastQueryParams.keyword);
                  if (item.fileThumbnail) {
                    item['src'] = environment.staticFileUrl + item.fileThumbnail;
                  }
                  // 处理著录信息
                  item.attributes = [];
                  if(item.properties){
                    item.attributes = this.getAttrList(item.materialCategory, item.textType);
                    item.attributes.forEach(e => {
                      e.value = item.properties[e.id+'Note'] ? item.properties[e.id+'Note'] : item.properties[e.id];
                      if (e.value) {
                        e.value = this.replaceKeyword(e.value, this.lastQueryParams.keyword);
                      }else{
                        e.value = '不详';
                      }
                    });
                  }
                })
              }
            }else{
              this.box.waring(res.msg);
            }
          }
        );
      }
    }

    // 替换关键字
    replaceKeyword(str, keyword) {
      if (!str) {
        return '';
      }
      const regex = new RegExp(keyword, 'gi');
      return str.replace(regex, '<b>' + keyword + '</b>');
    }

    // 根据materialCategory和textType获取属性列表
    getAttrList(materialCategory, textType) {
      let attrs = [];
      const item = this.fileCategoryOptions.find(e => e.id == materialCategory);
      if (item) {
        const item1 = item.childs.find(e => e.id == textType);
        if (item1) {
          attrs = item1.recordFileds;
        }else{
          attrs = item.recordFileds;
        }
      }
      return JSON.parse(JSON.stringify(attrs.slice(0,4)));
    }

    // 分页点击方法
    clickPageQuery (event) {
        this.pageBase['pageNum'] = event.current;
        this.pageBase['pageSize'] = event.size;
        this.getData();
    }

    // 获取一段文本中指定关键词前后的文本，并将关键词用 <b> 标签包裹起来
    extractContext(text, keyword) {
      // 去除 HTML 标签
      const cleanText = text.replace(/<[^>]*>/g, '');
      // 查找关键词第一次出现的位置
      const index = cleanText.indexOf(keyword);
      if (index === -1) {
          return '';
      }
      // 计算截取的起始和结束位置
      const start = Math.max(0, index - 50);
      const end = Math.min(cleanText.length, index + keyword.length + 50);
      // 截取前后 50 个字符
      const extractedText = cleanText.slice(start, end);
      // 给关键词套上 <span> 标签
      const highlightedText = extractedText.replace(keyword, `<b>${keyword}</b>`);
      return highlightedText;
    }

    // 查看详情  type: resource 查看资源详情；content 素材内容浏览
    clickViewDetail(item,type){
      event.stopPropagation();
      if(type == 'resource'){
        let param = { "upOrAdd": "View", "selectedData": item };
        this.create.createModal(MaterialViewComponent, param);
      }else{
        let params = {
          materialId: item.materialId,
          current: item.pagesNum,
          keyword: this.lastQueryParams.keyword
        };
        this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
      }
    }
}

